export const faqData = [
  {
    id: 1,
    question: "Need Help with Debt Management?",
    answer:
      "Yes, balance transfers can be an effective tool for managing debt by consolidating multiple high-interest debts into a single, lower-interest payment. However, it’s essential to consider fees, interest rates, and repayment terms to ensure it aligns with your financial goals.",
  },
  {
    id: 2,
    question: "Will a balance transfer always save me money?",
    answer:
      "Not necessarily. While balance transfers can reduce interest costs, fees associated with the transfer and the duration of the lower interest rate period can affect overall savings. It’s crucial to compare the total costs before proceeding.",
  },
  {
    id: 3,
    question: "Can I transfer balances between cards from the same bank?",
    answer:
      "Generally, banks do not allow balance transfers between their own credit cards. The purpose of a balance transfer is to move debt from one lender to another.",
  },
  {
    id: 4,
    question: "How does a balance transfer affect my credit score?",
    answer:
      "Applying for a new credit card or loan for a balance transfer can result in a hard inquiry, which may temporarily lower your credit score. However, timely repayments on the new account can improve your score over time.",
  },
  {
    id: 5,
    question: "What happens if I miss a payment on my balance transfer?",
    answer:
      "Missing a payment can lead to penalties, an increase in the interest rate, and a negative impact on your credit score. It’s crucial to make payments on time to maintain favorable terms.",
  },
  {
    id: 6,
    question: "Are there limits to how much I can transfer?",
    answer:
      "Yes, the amount you can transfer is typically limited by the credit limit of the new card or loan and the bank’s policies. Some banks may allow transfers up to a certain percentage of the credit limit.",
  },
  {
    id: 7,
    question:
      "Is it possible to transfer other types of debt to a credit card?",
    answer:
      "Some credit cards allow balance transfers from personal loans or other credit cards. However, this depends on the card issuer’s policies.",
  },
  {
    id: 8,
    question: "What should I do after completing a balance transfer?",
    answer:
      "Focus on timely repayments of the new balance to take full advantage of the lower interest rate. Avoid accumulating new debt on the old account to prevent further financial strain.",
  },
];

export const helpData = [
  {
    id: 1,
    needhelp: "Need help with this information? Click here",
    title: "Where to find information for the calculator",
    information: [
      {
        id: 1,

        subtitle: "Existing debt: Credit card debt to transfer",
        infotext:
          "You can check your credit card statement for details about the amount you owe. Alternatively, you can log in to your bank or credit card issuer's app or website to view the current outstanding balance. Ensure you use the total outstanding balance instead of the minimum due amount to get accurate results for your balance transfer.",
      },
      {
        id: 2,
        subtitle: "Existing debt: Interest rate",
        infotext:
          "The interest rate applicable on your credit card debt is often referred to as the Annual Percentage Rate (APR) or monthly interest rate in India. This rate can be found in your credit card statement under sections like 'Interest Charges', 'Finance Charges', or the terms and conditions shared with your credit card account. Use the APR to input an accurate value for interest in the calculator.",
      },
      {
        id: 3,
        subtitle: "Balance Transfer Loan: Processing Fee",
        infotext:
          "Most balance transfer loans or credit card balance transfers in India involve a processing fee. This fee is a one-time charge and varies depending on the lender or card issuer. You can find this information in the loan or credit card terms and conditions or by checking the lender’s website. Ensure this fee is factored into the calculation for accurate results.",
      },
      {
        id: 4,
        subtitle: "Balance Transfer Loan: New Interest Rate",
        infotext:
          "The new interest rate for a balance transfer will depend on the offer provided by your new lender or card issuer. This rate is usually lower than the existing interest rate on your current credit card. Check the lender’s website or promotional offers for this rate, often labeled as 'Balance Transfer Interest Rate' or 'Special Rate for Transfers'.",
      },
      {
        id: 4,
        subtitle: "Loan Tenure or Repayment Period",
        infotext:
          "The repayment period is the time you need to repay the transferred balance. This is typically specified by the lender and can vary between 6 to 84 months for personal loans and other credit products in India. For credit card balance transfers, shorter tenures like 3 to 12 months are common.",
      },
    ],
  },
];
